export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informations sur les contreparties"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Compte / E-mail / Téléphone"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ID / Adresse crypto / E-mail / Téléphone"])}
}